import { render } from "./EmbedBlock.vue?vue&type=template&id=1f78febd"
import script from "./EmbedBlock.vue?vue&type=script&lang=js"
export * from "./EmbedBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__